<div class="streaming-country-selector-wrapper" *ngIf="shouldDisplay">
  @if (type === 'in-cinemas') {
    <fa-icon [icon]="markericon" class="marker-icon"></fa-icon>
    <ush-location-selector
      [showMarker]="false"
      [enableRouterNavigation]="false"
      (locationSelected)="handleLocationSelected($event)"
    ></ush-location-selector>
  } @else if (type === 'watch-at-home' && isCountrySelectorEnabled) {
    <fa-icon [icon]="markericon" class="marker-icon"></fa-icon>

    <feature-streaming-country-selector
      (countryChanged)="onCountryChanged($event)"
    ></feature-streaming-country-selector>
  }
</div>
